<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import BackEnd from "../../lib/BackEnd";
  import { userList } from "../../lib/Store";
  import Utils from "../../lib/Utils";
  import type { IUser } from "../../types";
  const dispatch = createEventDispatcher();

  let list: IUser[] = [];
  userList.subscribe((l) => {
    console.log(l);
    list = l||[];
  });
  const loadData = () => {
    BackEnd.getUserList().then((ok) => {
      //      list = ok;
      userList.set(ok);
    });
  };

  const addUser = () => {
    let user: IUser = {
      key: Utils.generateId(),
      name: "",
      type: "customer",
    };
    dispatch("select", user);
  };

onMount(loadData);
</script>

<main>
  <div class="toolbar">
    <button on:click={addUser}> + Add User</button>
  </div>
  <div class="List">
    {#each list as u}
      <div
        class="ListItem"
        on:click={() => {
          dispatch("select", u);
        }}
      >
        <div>{u.key}</div>
        <div>{u.name}</div>
      </div>
    {/each}
  </div>
</main>

<style>
  div.List {
    border-radius: 0.5rem;
    margin-top: 1rem;
    display: block;
    border: solid 1px lightgrey;
    background-color: var(--bg-grey);
    height: 100%;
    overflow-y: auto;
    cursor: pointer;
  }
  div.List .ListItem {
    display: flex;
    background-color: white;
    align-items: stretch;
    padding-top: 1rem;
    transition: all ease-in-out 0.5s;
    margin: 0.3rem;
    border-radius: 0.2rem;
    justify-content: space-between;
  }

  div.List .ListItem:hover {
    background-color: var(--bg-blue);
    transition: all ease-in-out 0.5s;
  }

  .ListItem div {
    padding: 1rem;
    text-align: left;
  }
</style>
